import BoxLoading from "@componentsShared/placeholders/BoxLoading/BoxLoading";
import stl from "./AsideFilterLoading.module.css";

const AsideFilterLoading = () => {
  return (
    <>
      <aside className="pe-1 mt-1 m-hide">

          <BoxLoading className="mb-1"  divWidth={120} divHeight={30}/>
          <BoxLoading className="mb-2"  divWidth={252} divHeight={90}/>
          <BoxLoading className="mb-1"  divWidth={252} divHeight={130}/>
          <BoxLoading className="mb-2" numberOfLoaders={20} divWidth={252} divHeight={50}/>

      </aside>
      <div className={["m-show", stl.mobileLoading].join(" ")}>
        <BoxLoading
          className={stl.mobileHeaingShimmer}
          divHeight={28}
          
        />
        <BoxLoading
          className={stl.mobileSearchShimmer}
          divHeight={48}
          
        />
        <BoxLoading
          className={stl.mobilefiltersShimmer}
          divHeight={47}
          
        />
        <div className={stl.mobileTagsShimmer}>
          <BoxLoading divHeight={26}  />
          <BoxLoading divHeight={26}  />
        </div>
        <BoxLoading
          className={stl.mobileBannerShimmer}
          divHeight={120}
          
        />
        <BoxLoading
          className={stl.mobileTextShimmer}
          divHeight={48}
          
        />
      </div>
    </>
  );
};

export default AsideFilterLoading;
